module.exports = __webpack_public_path__ + "static/media/folder.17d1c7b2.svg";